export const PAGES = [
  { title: "dashboard", url: "/", active: (path) => !path.includes('stake/') && !path.includes('lottery/') },
  { title: "stake", url: "/stake", active: (path) => path.includes('stake/') },
  // { title: "lottery", url: "/lottery", active: (path) => path.includes('lottery/') },
];
